import React from 'react';
import './AboutUs.scss'
import { isAutoServicesTenant } from '../../utils/tenantBranding';

const AboutUs = () => {

  const fetchingTenant = window.location.hostname.split(".")[0];
  const autoServicesBranding = isAutoServicesTenant(fetchingTenant);
   
  const brandName = autoServicesBranding ? "Autoservices" : "Eurorepar";
  return (
    <div className="about-us-container">
      <h2>About Us</h2>

      {autoServicesBranding ? (
        <>
          <p>
            At <span>Autoservices Car Service</span>, we are passionate about keeping you and your vehicle safely on the road. With years of experience in the automotive industry, we've built a reputation for reliable, high-quality car maintenance and repair services tailored to meet the needs of every driver.
          </p>

          <p>
            Our team of technicians is dedicated to delivering expert care—whether it's routine servicing, diagnostics, or mechanical repairs. We use advanced diagnostic tools, genuine parts, and up-to-date repair techniques to ensure your vehicle performs at its best.
          </p>

          <p>
            What sets us apart is our commitment to transparency, customer satisfaction, and timely service. From your first visit to every return, you'll experience honest advice, fair pricing, and workmanship you can trust.
          </p>

          <p>
            Whether you're driving a compact car, SUV, or commercial vehicle, Autoservices Car Service is your one-stop shop for dependable automotive care.
          </p>
        </>
      ) : (
        <>
          <p>
            <span>{brandName} Car Service (ERCS)</span> is a global multi-brand car repair and maintenance network owned by <span>Stellantis</span>, one of the world's leading automotive groups. Established in 2002 in France, ERCS has grown to serve customers in over <span>32 countries</span>, with more than <span>6,800 points of service</span> worldwide.
          </p>

          <p>
            Launched in India with a vision to offer <span>cost-effective</span>, <span>reliable</span>, and <span>high-quality</span> car servicing for all vehicle brands, ERCS is committed to delivering transparency, convenience, and trust to every customer. Whether your vehicle is within warranty or beyond it, our independent network of workshops is designed to meet the evolving needs of today's smart car owners.
          </p>
          
          <p>Our mission is to:</p>
          <ul>
            <li>Connect customers with <span>trusted partner garages</span></li>
            <li>Empower independent workshops through modern tools, training, and support</li>
            <li>Promote the <span>{brandName}</span> range of quality aftermarket parts</li>
          </ul>

          <p>Backed by Stellantis, ERCS India combines global expertise with local execution—offering:</p>
          <ul>
            <li>Multi-brand spare parts and diagnostics</li>
            <li>Online service booking via mobile app</li>
            <li>Genuine Mopar and {brandName} parts with <span>100% warranty</span></li>
            <li>Digitally enabled service centers with corporate branding</li>
            <li>Certified training, technical assistance, and business incentives for our partners</li>
          </ul>

          <p>
            With state-of-the-art infrastructure, skilled technicians, and a digitally connected ecosystem, ERCS India is redefining multi-brand car servicing across the country.
          </p>
        </>
      )}
        {autoServicesBranding ? ( 
          <h3 style={{ color: '#f57c00', marginTop: '2rem', fontFamily: 'Karbon-semi', fontSize: '1.6rem' }}>
            Expert Care for Every Car.
          </h3>

        ) : (

<>
          <h3 style={{ color: '#f57c00', marginTop: '2rem', fontFamily: 'Karbon-semi', fontSize: '1.6rem' }}>
            Your car. We care.
          </h3>
          </>
        ) }

    </div>
  );
};

export default AboutUs;
